import React, { useEffect, useState } from 'react';
import './WineList.scss'
import { WineType, wine } from '../../models/wine';
import WineElement from './WineElement';
import WineFilterModal from './WineFilterModal';
import { BsSliders } from "react-icons/bs"
import { DeepCopy, DeepCopyArray, distinct } from '../../Helper';
import WineChips from './WineChips';

export interface WineFilters {
    types: string[];
    charactestics: string[];
}

export interface WineListMenuProps {
    wines?: wine[]
}

function WineList(props: WineListMenuProps) {
    const [wines, setWines] = useState<wine[]>();
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [wineFilters, setWineFilters] = useState<WineFilters>({ types: [], charactestics: [] });
    const [allWinesCharacteristics, setAllWineCharacteristics] = useState<string[]>([]);
    useEffect(() => {
        setWines(props.wines);
        Object.values(WineType).map((type) => console.log(type));
        // applyFilter();
    }, [])
    useEffect(() => {
        parseAllWineCharacteristics();
    }, [wines])

    useEffect(() => {
        filterWines();
    }, [modalOpen])

    const filterWines = () => {
        var filtered = props.wines;
        if (wineFilters.types.length > 0)
            filtered = filtered?.filter(_ => wineFilters.types.map(f => WineType[f as keyof typeof WineType]).includes(_.type!));
        if (wineFilters.charactestics.length > 0)
            filtered = filtered?.filter(_ => {
                var all = DeepCopyArray(wineFilters.charactestics);
                all.push(..._.caratteristiche);
                var reduced = distinct(all);
                if (reduced.length < all.length)
                    return true;
                else
                    return false;
            });
        setWines(filtered);
    }

    useEffect(() => { console.log(allWinesCharacteristics) }, [allWinesCharacteristics])

    const parseAllWineCharacteristics = () => {
        if (!!wines) {
            var chars = wines.map(_ => _.caratteristiche).reduce(function (a, b) { return a.concat(b); }, []);
            chars.shift();
            setAllWineCharacteristics(distinct(chars) as string[])
        }
    }

    const Bollicine = () => wines?.filter(_ => _.type == WineType.Bollicine);
    const Bianchi = () => wines?.filter(_ => _.type == WineType.Bianchi);
    const Rossi = () => wines?.filter(_ => _.type == WineType.Rossi);
    const Rosati = () => wines?.filter(_ => _.type == WineType.Rosati);
    const Dolci = () => wines?.filter(_ => _.type == WineType.Dolci);

    return (
        <div>
            <div>

            </div>
            <div className='wine-menu-title-wrapper'>
                <div>

                    <div className='wine-menu-title'>
                        Carta dei vini
                    </div>
                    <div className='wine-filter-box'>
                        <BsSliders onClick={() => setModalOpen(true)} className='wine-filter-icon' />
                    </div>
                    <div>
                        <WineChips wineFiltersAccessor={[wineFilters, setWineFilters]} refreshList={filterWines} />
                    </div>
                </div>
            </div>
            <div className='menu-content'>

                {/* Bollicine */}
                {
                    !!Bollicine() && Bollicine()!.length > 0 ?
                        <div>
                            <div className='menu-title-small'>Bollicine</div>
                            {
                                Bollicine()?.map((w: wine) => <WineElement key={`${w.nome}_${w.vol}_${w.cantina}`} wine={w} />)
                            }
                        </div> : <></>
                }
                {/* Vini Bianchi */}
                {
                    !!Bianchi() && Bianchi()!.length > 0 ?
                        <div>
                            <div className='menu-title-small'>Bianchi</div>
                            {
                                Bianchi()?.map((w: wine) => <WineElement key={`${w.nome}_${w.vol}_${w.cantina}`} wine={w} />)
                            }
                        </div> : <></>
                }
                {/* Vini Rosati */}
                {
                    !!Rosati() && Rosati()!.length > 0 ?
                        <div>
                            <div className='menu-title-small'>Vini Rosati</div>
                            {
                                Rosati()?.map((w: wine) => <WineElement key={`${w.nome}_${w.vol}_${w.cantina}`} wine={w} />)
                            }
                        </div> : <></>
                }
                {/* Vini Rossi */}
                {
                    !!Rossi() && Rossi()!.length > 0 ?
                        <div>
                            <div className='menu-title-small'>Vini Rossi</div>
                            {
                                Rossi()?.map((w: wine) => <WineElement key={`${w.nome}_${w.vol}_${w.cantina}`} wine={w} />)
                            }
                        </div> : <></>
                }
                {/* Dolci */}
                {
                    !!Dolci() && Dolci()!.length > 0 ?
                        <div>
                            <div className='menu-title-small'>Dolci</div>
                            {
                                Dolci()?.map((w: wine) => <WineElement key={`${w.nome}_${w.vol}_${w.cantina}`} wine={w} />)
                            }
                        </div> : <></>
                }
            </div>
            <WineFilterModal open={modalOpen} onClose={() => setModalOpen(false)} allWineCharacteristics={allWinesCharacteristics} wineFiltersAccessor={[wineFilters, setWineFilters]} />
        </div>
    );
}

export default WineList;